import React from 'react';
import { VelocityComponent } from 'velocity-react';
import 'velocity-animate';
import 'velocity-animate/velocity.ui';

import './betaTermsOverlay.css';

class BetaTermsOverlay extends React.Component {
  render() {
    return (
      <VelocityComponent animation="transition.fadeIn" duration={650} runOnMount={true}>
        <div className="terms-overlay-wrapper">
          <div className="terms-overlay-container">
            <div className="terms-overlay-close" onClick={this.props.toggleOverlay}>
              &times;
            </div>
            <article>
              <h1>Terms of Use</h1>
              <section>
                <p>
                  You (“Customer”) will have access to the Beta Product for purposes of implementing user-generated
                  content in email templates. Beta Product is an API that allows email marketers to easily embed user
                  generated and/or Customer-provided photos in their Customer email marketing campaigns using responsive
                  HTML code. Close collaboration and frequent feedback from Customer will be required for the success of
                  this Test Period. The Test Period will start with a kick-off meeting where Olapic and Customer will
                  define owners for tech, analytics, and design, define locations on Client’s email templates for
                  implementation, and define initial success metrics for the test.
                </p>
              </section>
              <section>
                <h2>Test Period</h2>
                <p>You will retain access to the Beta Product until March 31st 2019 (“Test Period”).</p>
              </section>

              <section>
                <h2>Marketing</h2>
                <p>
                  Customer agrees to be featured as a client on the Olapic website. Customer agrees to contribute to the
                  public launch of the Beta Product pending successful implementation of Beta Product by Customer during
                  Test Period.
                </p>
              </section>
              <section>
                <h2>Additional Terms</h2>
                <p>
                  Customer agrees and understands that the Beta Product is an early-adoption version which has not been
                  commercially released and is provided on a trial basis.
                </p>
                <p>
                  The Beta Product may not contain the same functionality as products and services that Olapic makes
                  available for commercial release.
                </p>
                <p>
                  Customer will gain no right, title or interest in or to any commercially released versions by virtue
                  of Customer’s Feedback (as defined below) and Olapic has no obligation to support or maintain the Beta
                  Product after the Term. The Beta Product is provided free of charge in exchange for Customer’s
                  Feedback concerning the release. “Feedback” means communications and reports about errors, problems,
                  defects in, or suggestions for changes and improvements to the Beta Product. All Feedback shall be
                  owned by Olapic and may be used by Olapic in the development of any commercially released versions.
                  Customer shall not disclose to any third party any Feedback or results of any testing of the Beta
                  Product. Additionally, Customer agrees to participate in surveys and case studies related to the Beta
                  Product.
                </p>
                <p>
                  Provided the results are successful, Customer must participate in a public branded case study of Beta
                  Product if Olapic decides to move forward with the usage of Beta Product after the Test Period.
                </p>
                <p>
                  Customer may not disclose any Feedback or results (except with respect to Customer’s third party
                  analytics or tracking partners who may have access to results by virtue of the services they provide
                  to Customer) from any testing of the Beta Product.
                </p>
                <p>
                  Customer is under no obligation to purchase Beta Product access upon expiration or termination of the
                  Test Period.
                </p>
              </section>
            </article>
          </div>
        </div>
      </VelocityComponent>
    );
  }
}

export default BetaTermsOverlay;



// WEBPACK FOOTER //
// ./src/components/BetaTermsOverlay/betaTermsOverlay.js